<template lang="pug">
b-container#page.search
  b-row
    .col-4
      h2 Nueva búsqueda
      b-form(inline v-if="user")
        b-form-group#input-counter-group(label='Counter:' description="¡Buenos dias!")
          b-form-input#input-counter.mr-sm-2(v-model="user.email" size='sm' placeholder='Usuario' disabled)
          b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      //b-form(@submit='onSubmit' @reset='onReset')
        h3 Datos de cliente
        b-form-group#input-firstName-group(label='Nombres:' label-for='input-firstName')
          b-form-input#input-firstName(v-model='form.firstName' /*required=''*/ placeholder='Nombres del cliente')
        b-form-group#input-lastName-group(label='Apellidos:' label-for='input-lastName')
          b-form-input#input-lastName(v-model='form.lastName' /*required=''*/ placeholder='Apellidos del cliente')
        h3 Fechas
        b-form-group#input-saleDate-group(label='Fecha:' label-for='input-saleDate')
          b-form-datepicker#input-saleDate(v-model="form.saleDate")
        h3 Rutas
        b-form-group#input-searchLocation-group(label='Buscar:' label-for='input-searchLocation')
          vue-bootstrap-typeahead#input-searchLocation(v-model="form.searchLocation" :data="['Arequipa, AQP, Rodríguez Ballón', 'Cuzco, CUZ, Alejandro Velazco Astete', 'Lima, LIM, Internacional Jorge Chávez', 'Piura, PIU, Capitán FAP Carlos Concha', 'Iquitos, IQT, Coronel FAP Francisco Secada V.']")
    .col-8
      h2 Operaciones
      b-card-group
        b-card.mt-3(bg-variant="info" text-variant="white")
          b-form(inline)
            b-form-group#input-counter-group(label='Buscar por:')
              //b-form-select#input-counter.mr-sm-2(v-model="showBy" size='sm' :options="showByOptions")
              b-form-input#input-search.mr-sm-2(v-model="filter" size='sm' type="search")
              b-form-select#input-searchOn.mr-sm-2(v-model="filterOn" size='sm' :options="sortOptions")
            //b-form-group#input-counter-group.mr-sm-2(label='Desde:')
              b-form-datepicker#input-queryStartDate(v-model="form.startDate" size='sm' inline)
            //b-form-group#input-counter-group.mr-sm-2(label='Hasta:')
              b-form-datepicker#input-queryEndDate(v-model="form.endDate" size='sm' inline)
              //b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      h3 Tablero de Control
      b-container(style="display:none")
        b-row
          .col-6
            h4 Ventas del día
            b-card-group(deck)
              b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong {{getDaySaleCount()}}
                  br
                  span Ventas
              b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 0
                  br
                  span Total en S/
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 705
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 13
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 116
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 110
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 20
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 20
            h4.mt-3 Ventas del mes
            b-card-group(deck)
              b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 0
                  br
                  span Ventas
              b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 0
                  br
                  span Total en S/
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 212
              //b-card.text-center(img-src="" img-alt="Card image" img-left bg-variant='info' text-variant='white')
                b-card-text(align="left")
                  strong 212
          .col-6
            h4 Diagrama general
            px-chart
      h4 Tabla de operaciones
      b-table(:filter="filter" :filter-included-fields="computedFilterOn" striped hover responsive :items="reverse(operations)" :fields="fields" @filtered="onFiltered")
        template(#cell(counterId)="operation") {{ operation.item.counterId ? operation.item.counterId.firstName: '' }}
        template(#cell(passengerGroup)="operation") {{ operation.item.clientId.firstName }} {{ operation.item.clientId.lastName }}
        template(#cell(documentType)="operation") {{ operation.item.clientId.documentType }}
        template(#cell(documentNumber)="operation") {{ operation.item.clientId.documentNumber }}
        template(#cell(routeGroup)="operation")
          pre(v-for="route in operation.item.routeGroup") {{ route.ICAO }}
        template(#cell(currency)="operation") {{ operation.item.currency }}
        template(#cell(total)="operation") {{ operation.item.total }}
        template(#cell(operator)="operation") {{ operation.item.saleId ? operation.item.saleId.operator : '' }}
        template(#cell(it)="operation") {{ operation.item.saleId ? operation.item.saleId.it: '' }}
        template(#cell(saleDate)="operation") {{ operation.item.saleId ? operation.item.saleId.saleDate: '' }}
        template(#cell(airlineCode)="operation") {{ operation.item.airlineCode }}
        template(#cell(formNumber)="operation") {{ operation.item.saleId ? operation.item.saleId.formNumber: '' }}
        template(#cell(ticketNumber)="operation") {{ operation.item.saleId ? operation.item.saleId.ticketNumber: '' }}
        template(#cell(counterReportDate)="operation") {{ operation.item.saleId ? operation.item.saleId.counterReportDate: '' }}
        template(#cell(saleDescription)="operation") {{ operation.item.saleId ? operation.item.saleId.saleDescription: '' }}
      h4 Descargar tabla
      b-button(type='button' v-on:click='download()' variant='primary') Descargar hoja de cálculo
      px-cards(title="Últimas operaciones")
</template>

<script>
// @ is an alias to /src
import PxCard from "@/components/PxCard.vue";
import PxCards from "@/components/PxCards.vue";
import PxChart from "@/components/PxChart.vue";

import { mapState, mapGetters } from "vuex";

// @ is an alias to /src
import api from "@/assets/scripts/api.js";

export default {
  name: "Search",
  components: {
    PxCard,
    PxCards,
    PxChart,
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        saleDate: "",
        searchLocation: "",
        startDate: "",
        endDate: "",
      },
      showByOptions: [
        { text: "Todos", value: "all" },
        { text: "Counter", value: "counter" },
        { text: "Operador", value: "operator" },
        { text: "Forma de pago", value: "paymethod" },
      ],
      options: [
        { text: "Todos", value: "all" },
        { text: "Counter 1", value: "counter" },
        { text: "Counter 2", value: "operator" },
        { text: "Counter 3", value: "paymethod" },
      ],
      showBy: "all",
      filter: null,
      filterOn: [],
      fields: [
        {
          key: "counterId",
          label: "Counter",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "passengerGroup",
          label: "Cliente",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "documentType",
          label: "Tipo doc.",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "documentNumber",
          label: "N° doc.",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "routeGroup",
          label: "Ruta",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "currency",
          label: "Moneda",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "total",
          label: "Tot. neto",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "operator",
          label: "Operador",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "it",
          label: "IT",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "saleDate",
          label: "Fecha venta",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "airlineCode",
          label: "Cod. aereolínea",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "formNumber",
          label: "N° forma",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "ticketNumber",
          label: "N° boleto",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "counterReportDate",
          label: "Fecha reporte",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "saleDescription",
          label: "Descripción",
          sortable: true,
          sortDirection: "asc",
        },
      ],
    };
  },
  computed: {
    ...mapState(["user", "operations"]),
    ...mapGetters(["user", "operations"]),
    sortOptions() {
      const list = this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
      list.unshift({ text: "", value: null });
      console.log(list);
      return list;
    },
    computedFilterOn() {
      return this.filterOn;
    },
  },
  mounted() {
    //this.$store.dispatch("getOperations");
  },
  methods: {
    download() {
      this.getXlsx(
        this.reverse(this.operations),
        [
          "__v",
          "_id",
          "airlineCode",
          "clientId",
          "counterId",
          "createdAt",
          "currency",
          "passengerGroup",
          "routeGroup",
          "total",
        ],
        "tabla-flight-center.csv"
      );
    },
    getXlsx(jsonData, header, name = " ^u  ^m  ^j    .xlsx") {
      if (!Array.isArray(jsonData))
        throw new Error(`${jsonData} is must be Array and not empty!`);
      if (!Array.isArray(header))
        throw new Error(`${header} is must be Array and not empty!`);
      let str = header.toString() + "\n";
      for (let i = 0; i < jsonData.length; i++) {
        for (let item in jsonData[i]) {
          str += `${JSON.stringify(jsonData[i][item]) + "\t"};`;
        }
        str += "\n";
      }
      let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
      // ^`^z  ^g ^h^{   a  ^g     ^~ ^n
      var link = document.createElement("a");
      link.href = uri;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async onSubmit(evt) {
      evt.preventDefault();
      try {
        //this.$store.dispatch("addOperation", this.form);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("operationSubmited");
      }

      /*alert(this.form);
      this.$store.dispatch("addOperation", {
        clientId: {
          firstName: this.form.firstName,
        },
        passangerGroupID: {
          passengerNumber: this.form.passengerNumber,
        },
      });
      //this.$store.dispatch("loadItems");
      alert(JSON.stringify(this.form));*/
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reverse: (value) => {
      console.log(value);
      return value.slice().reverse();
    },
    async getDaySaleCount() {
      let cambio = 0;
      try {
        const res = await api.getTipoCambio();
        const data = res.data;
        // TODO getDaySale
        cambio = data ? 0 : 0;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("getDaySaleCount");
      }
      return cambio;
    },
  },
};
</script>

<style lang="stylus" scoped>
.card-body {
  padding: 1em;
}

.card-deck .card {
  max-width: calc(50% - 30px);
  min-width: calc(50% - 30px);
}

.card-deck .card:nth-child(n+3) {
  margin-top: 1rem;
}
</style>
